import { Injectable } from '@angular/core';
import { CONSTANTS } from 'src/app/core/constants/constants';
import { REGEX } from 'src/app/core/constants/regex';
import { Material } from 'src/app/core/models/materials/material.model';
import { Simulation } from 'src/app/core/models/simulation.model';
import { SimulationManagerService } from '../../simulation-manager.service';

@Injectable({
  providedIn: 'root',
})
export class MaterialsService {
  constructor(private simulationService: SimulationManagerService) {}

  get simulation(): Simulation {
    return this.simulationService.simulation;
  }

  isObjectInUse(id: number): string[] | null {
    const foundInLines = this.simulation.line
      .filter((l) => {
        const foundSegMatId = l.segmentMaterialId.find((segMatId) => segMatId === id);
        return foundSegMatId === id;
      })
      .map((l) => l.title);

    return foundInLines.length ? foundInLines : null;
  }

  isObjectByIdInUse(id: number): number[] | null {
    const foundInLines = this.simulation.line
      .filter((l) => {
        const foundSegMatId = l.segmentMaterialId.find((segMatId) => segMatId === id);
        return foundSegMatId === id;
      })
      .map((l) => l.internalId);

    return foundInLines.length ? foundInLines : null;
  }

  isMaterial(type: string): boolean {
    return (
      type === CONSTANTS.MATERIAL_TYPES.CONNECTOR ||
      type === CONSTANTS.MATERIAL_TYPES.FLEX_LINE ||
      type === CONSTANTS.MATERIAL_TYPES.RIGID_TUBE ||
      type === CONSTANTS.MATERIAL_TYPES.STRESS_JOINT ||
      type === CONSTANTS.MATERIAL_TYPES.CABLE
    );
  }

  getCofLayers(material: Material): Array<{ id: any; name: string; description: string }> {
    if (!material?.cofData) {
      return [];
    }

    const cofData = material?.cofData;
    const splittedCof = cofData.split('#');
    const targetGroups = splittedCof.filter((group) => group.startsWith('07'));

    if (!targetGroups.length) {
      return [];
    }

    const targetGroupLines = targetGroups[0].split(REGEX.COF_LINE_BREAK);
    const layersRaw = targetGroupLines
      .slice(2)
      .map((x) => this.layerStringToObject(x))
      .filter((x) => x !== null);
    layersRaw.forEach((lw) => (lw.id = material?.internalId));
    return layersRaw;
  }

  layerStringToObject(rawStr: string): {
    id: any;
    name: string;
    description: string;
  } {
    const matches = rawStr.match(REGEX.COF_LAYER);

    if (matches === null) {
      return null;
    }

    try {
      return {
        id: null,
        name: matches[1],
        description: matches[2].trim(),
      };
    } catch (err) {
      return null;
    }
  }
}
